Customer.Filters ||= {}

class Customer.Filters.CloneFilterView extends Backbone.View
  template: JST["backbone/templates/customer/filters/clone_filters"]

  initialize: (@options = {}) ->
    @modal =
      title: I18n.t('customer.dashboard.filters.modal.clone.title')
      buttons: []
    @globalEditable = @options.globalEditable
    @addModalButtons()
    @newQuery = _.clone(@model._queryWithDefaults().get('query'))

  addModalButtons: ->
    @modal.buttons.unshift {title: I18n.t('customer.dashboard.filters.save'), event: 'onSave'}
    @modal.buttons.unshift {title: I18n.t('customer.dashboard.filters.close'), event: 'closeModal'}

  render: ->
    @$el.html(@template(name: @model.attributes.name, isGlobal: @model.isGlobal(), globalEditable: @globalEditable))
    @

  onSave: =>
    @_updateAttrs()
    @model.update((filter) => @trigger('save', filter))
    @closeModal()

  closeModal: (_triggerKeepAlive) =>
    @modalTab.destroy()

  _updateAttrs: ->
    @model.set('name', @$el.find('#filter_title_input').val())
    @_setGlobal()

  _setGlobal: ->
    if @globalEditable
      global = @$el.find('#global-status-checkbox')[0].checked
      @_deleteUserId if global
      @model.updateGlobal(global)
    else
      @model.updateGlobal(false)

  _deleteUserId: ->
    @model.unset('user_id', {silent: true})
